module.exports = "/_next/static/images/deb91bbf24ff62bc6779596dc9f4ecf7-rates-icon.svg.webp";